import './navbar.css'
import Logo from '../../assets/Jungle.JPG'
import data from './data'
import { GiSpaceSuit } from "react-icons/gi";

const Navbar = () => {
  return (
    <nav>
      <div className="container nav__container">
        <a href="index.html" className='nav__logo'>
          <img src={Logo} alt="Logo" />
        </a>
        <ul className='nav__menu'>
            {
               data.map(item => <li key={item.id}><a href={item.link}>{item.title}</a></li>)
            }
        </ul>
        <button id='theme__icon'><GiSpaceSuit/></button>
      </div>
    </nav>
  )
}

export default Navbar    